import { useSearchParams } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { DEFAULT_TAB, isValidSettingsTab, SettingsTabKey } from '../config';

export function useSettingsTabs() {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = useMemo(() => {
    const tab = searchParams.get('tab');
    if (isValidSettingsTab(tab)) {
      return tab;
    }
    return DEFAULT_TAB;
  }, [searchParams]);

  // Sync URL if invalid or missing, but do it in useEffect to avoid bad state update during render
  useEffect(() => {
    const tab = searchParams.get('tab');
    if (!isValidSettingsTab(tab)) {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.set('tab', DEFAULT_TAB);
      setSearchParams(nextParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const setActiveTab = (key: SettingsTabKey) => {
    if (key === activeTab) return;
    
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('tab', key);
    setSearchParams(nextParams, { replace: true });
  };

  return { activeTab, setActiveTab };
}
